import React, { useEffect, useState } from "react";
import { validationIotCallingInput } from "src/pages/Cms/utils";
import { isDisableSubmit } from "src/utils";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";

const initialValue = {
  id: "",
  phoneNumber: "",
  name: "",
};

function IotCallingForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateIotCallingForm = (fieldValues = values) => {
    let temp = validationIotCallingInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateIotCallingForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateIotCallingForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="phoneNumber"
        value={values.phoneNumber}
        label="Phone Number"
        type="text"
        onChange={handleOnChange}
        error={errors.phoneNumber}
      />

      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default IotCallingForm;
